module.exports = __webpack_public_path__ + "img/car_s142.490b0f2a.png";